export default function () {

    var am2 = window.am2 || {};
    am2.initialized = {};

    (function ($) {
        'use strict';

        am2.main = {

            toggleText: function( el, textOne, textTwo ) {
                var currentText = el.innerText;
                return el.innerText = currentText == textOne ? textTwo : textOne;
            },

            jsHeaderSearch: function(){
                $(document).ready(function(){
                    $('.search__icon, .resp__search-icon').on('click', function(){
                        $('.js-header-search').addClass('active');
                    });
                    $('.svg-icon--close-dims').on('click', function(){
                        $('.js-header-search').removeClass('active');
                    });
                });
                if($(window).width() < '768'){
                   
                    $('.filters-v1__label, .filters-v2__label').text('Search Events');

                    $('.main .filters-v1__label').on('click', function(){
                        $('.main .filters-v1__date-from, .main .filters-v1__date-to, .main .filters-v1__category, .main .filters-v1__search').slideToggle();
                    });
                }
            },
            autoCompliteSearch: function(args){
                // check if already initialized
                if(typeof (am2.initialized.jqueryUI) !== 'undefined' && am2.initialized.jqueryUI === true) {
                    return false;
                }
                am2.initialized.jqueryUI = true;

                $(document).on('keyup', '#'+ args.searchID +'', function(e){
                    $('#'+ args.searchID +'').keydown(function(event){
                        if(event.keyCode == 13) {
                          event.preventDefault();
                          return false;
                        }
                      });
                    var _this = $(this);

                    var val = _this.val();
                    var valUrl = _this.text();
                    $( '#'+ args.searchID +'' ).autocomplete({
                        minLength: 3,
                        appendTo: '#'+ args.formID + '',
                        source: function( request, response ) {
                            $.ajax({
                                dataType: "json",
                                type : 'Get',
                                url: 'http://texaschristmasevents.eventzone.co/api/rest/v1/cities/'+ val,
                                success: function(data) {
                                    $('input.suggest-user').removeClass('ui-autocomplete-loading');  
                                    // hide loading image
                    
                                    response( $.map( data, function(item) {
                                        // your operation on data
                                        return {
                                            label: item,
                                            value: item
                                            //$('#dropdown').append('<option value="'+response[key]+'">');
                                        }
                                    }));
                                },
                                error: function(data) {
                                    $('input.suggest-user').removeClass('ui-autocomplete-loading');  
                                }
                            });
                        },
                        select: function(event, ui) {
                            window.location.href = '/'+ ui.item.value.toLowerCase().replace(/\s+/g, "-");
                        },
                    });
                });
                
            },
            ajaxSearch: function(){
                if(typeof (am2.initialized.ajaxSearch) !== 'undefined' && am2.initialized.ajaxSearch === true) {
                    return false;
                }
                am2.initialized.ajaxSearch = true;
                am2.offset_events = 0;

                $(document).ready(function(){
                    if($('.filters-v1').find('.js-ajax-search')){
                        searchForm();
                    }
                });
                $(document).ready(function(){
                    $('#load-more').on('click', function(){
                        $(this).text('Loading...');
                        loadMore();
                    });
                });
                
                function loadMore(){
                    var searchTerm = $('.js-ajax-search').find('.filters-v1__search-field').val();
                    var date_s = $('.js-ajax-search').find('.date_s').val();
                    var date_e = $('.js-ajax-search').find('.date_e').val();
                    var event_type = $('.js-ajax-search').find('.filters-v1__categories').val();
                    var loader = $('.js-ajax-search').parent().parent().find('.spinner');
                    var city = $('#load-more').data('city');
                    am2.offset_events = am2.offset_events + 9;

                    $.ajax({
                            url: am2.ajaxurl,
                            data:{
                                'offset': am2.offset_events,
                                'term': searchTerm,
                                'date_s': date_s,
                                'date_e': date_e,
                                'event_type': event_type,
                                'action': 'am2_filters',
                                'ppp': '9',
                                'city' : city
                            }, // form data
                            type: 'GET', // GET
                            beforeSend:function(data){

                            },
                            success:function(data){
      
                            },
                        }).done(function(data){
                            if(data.response != 'no_events'){
                                $('#response').append(data);
                                $('#load-more').text('Load more');
                                $('.js-match-height').matchHeight(); 
                            }else{
                                $('#load-more').fadeOut();
                                $('#response').append(data.message);
                            }
                            
                        });
                        return false;     
                }
                function searchForm(){
                    $('.js-ajax-search').on('submit',function(){
                        var searchTerm = $('.js-ajax-search').find('.filters-v1__search-field').val();
                        var date_s = $('.js-ajax-search').find('.date_s').val();
                        var date_e = $('.js-ajax-search').find('.date_e').val();
                        var event_type = $('.js-ajax-search').find('.filters-v1__categories').val();
                        var city = $('.js-ajax-search').find('.filters-v1__city').val();
                        var loader = $('.js-ajax-search').parent().parent().find('.spinner');
                        var filter = $(this);
                        $('#response').fadeOut('slow').empty();
                        loader.show();
                        filter.attr('action', am2.ajaxurl );
                        $.ajax({
                            url: filter.attr('action'),
                            data:{
                                'offset': 0,
                                'term': searchTerm,
                                'date_s': date_s,
                                'date_e': date_e,
                                'event_type': event_type,
                                'city': city,
                                'action': 'am2_filters',
                                'ppp': '9',
                            }, // form data
                            type: filter.attr('method'), // GET

                            beforeSend:function(xhr){
                                filter.find('button').text('Processing...'); // changing the button label
                            },
                            success:function(data){
                                 $('.search__button').replaceWith('<button type="submit" value="search" class="search__button">Search</button>');
                            },
                        }).done(function(data){
                            loader.hide();
                            $('#response').html('');
                            $('#response').html(data).fadeIn('slow');
                            $('.js-match-height').matchHeight();
                            $('.global-load-more').show();
                        });
                        return false;                
                    });
                }
                    
            },
            datePicker: function(){
                if(typeof (am2.initialized.datePicker) !== 'undefined' && am2.initialized.datePicker === true) {
                    return false;
                }
                am2.initialized.datePicker = true;

                $( ".js-date-picker"  ).datepicker({
                    "showAnim": "slideDown",
                    dateFormat: 'M-d-yy'
                 });          
            },
            popUpShare: function(){
                // check if already initialized
                if(typeof (am2.initialized.popUpShare) !== 'undefined' && am2.initialized.popUpShare === true) {
                    return false;
                }
                am2.initialized.popUpShare = true;
                
                $.fn.sharePopup = function (e, intWidth, intHeight, blnResize, w, h) {

                e.preventDefault();

                // Set values for window
                if($(window).width() <= 768){
                    intWidth = intWidth || '360';
                    intHeight = intHeight || '150';
                }else{
                    intWidth = intWidth || '500';
                    intHeight = intHeight || '400';
                }
                
                var left  = ($(window).width()/2)-(500/2);
                var top   = ($(window).height()/2)-(400/2);
                var strResize = (blnResize ? 'yes' : 'no');

                // Set title and open popup with focus on it
                var strTitle = ((typeof this.attr('title') !== 'undefined') ? this.attr('title') : 'Social Share'),
                    strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize + ', top='+top+', left='+left,            
                    objWindow = window.open(this.attr('href'), strTitle, strParam).focus();
                }
                $('.share').on("click", function(e) {
                  $(this).sharePopup(e);
                });
            },

            animateElements: function () {
                // check if already initialized
                if(typeof (am2.initialized.animateElements) !== 'undefined' && am2.initialized.animateElements === true) {
                    return false;
                }
                am2.initialized.animateElements = true;

                var $waypoints = $( '.js-animate' );
                $waypoints.each(function () {
                    $( this ).waypoint( function( direction ) {
                        var $element = $( this.element );
                        $element.addClass( 'fx--active' );
                    }, {
                        offset: '80%'
                    })
                });
            },

            shareCount: function(){

                var permalink = am2.current_page;
                //console.log(permalink);

                // Twitter no longer provides this information. If the count is
                // important to you I recommend using their drop-in share button.
                /* var getTwitterCount = function () {
                  $.getJSON('https://cdn.syndication.twitter.com/widgets/tweetbutton/count.json?url='+permalink, function(data){
                    var twitterShares = data.count;
                    if (data.count) {
                        $('.share-social__link--twitter').append('<span class="count count--twitter">' +twitterShares+ '</span>');
                    }else {
                        $('.share-social__link--twitter').append('<span class="count count--twitter">0</span>');
                    }
                  });
                };
                
                getTwitterCount(); */
                
                var getFacebookCount = function () {
                  $.getJSON('https://graph.facebook.com/'+permalink, function(data){
                    var facebookShares = data.share.share_count;
                    //console.log(facebookShares);
                    if (facebookShares) {
                        $('.share-social__link--facebook').append('<span class="count count--facebook">' +facebookShares+ '</span>');
                    }else {
                        $('.share-social__link--facebook').append('<span class="count count--facebook">0</span>');
                    }
                  });
                };
                
                getFacebookCount();
                
                /* var getPinterestCount = function () {
                  $.getJSON('https://api.pinterest.com/v1/urls/count.json?url=' + permalink + '&callback=?', function(data) {
                    var pinterestShares = data.count;
                    if (pinterestShares) {
                      $('.pinterest').append(' ('+pinterestShares+')');
                    }
                  });
                };
                
                getPinterestCount(); */
            },
            instagramLoad: function() {
                if(typeof (am2.initialized.twig) !== 'undefined' && am2.initialized.twig === true) {
                    return false;
                }
                am2.initialized.twig = true;

                $('.see-all-galleries a').on('click', function(e){
                    e.preventDefault();
                    var nextMaxId = $('.insta-next-max-id').data('next-max-id');
                    var template = twig({
                        href: am2.template_directory + "/views/components/" + 'gallery-masonry.twig',
                        async: false,
                        load: function(template) {
                            $.ajax({
                                url: am2.ajaxurl,
                                method: 'POST',
                                beforeSend: function ( xhr ) {
                                    //xhr.setRequestHeader( 'X-WP-Nonce', truthdig.nonce );
                                },
                                data:{
                                    'action': 'instagram_load_more',
                                    'next-max-id': nextMaxId,
                                },
                                success: function( data ) {
                                    var object = {images: data.feed};
                                    var resultHTML = template.render(object);
                                    var $container = $('.gallery-masonry-v1 .grid');
                                    var result = $(resultHTML);
                                    $container.append(result).imagesLoaded(function(){
                                        $container.masonry( 'appended', result, true );
                                    });
                                    $('.insta-next-max-id').data('next-max-id', data.next_max_id);
                                    if(data.next_max_id == 'end') {
                                        // remove load more
                                        $('.see-all-galleries a').fadeTo("slow" , 0).fadeOut('slow');
                                    }
                                }
                            });

                        }
                    });
                });
            },

            masonryGallery: function() {
                // check if already initialized
                if(typeof (am2.initialized.masonryGallery) !== 'undefined' && am2.initialized.masonryGallery === true) {
                    return false;
                }
                am2.initialized.masonryGallery = true;

                am2.main.loadScript(am2.templateDirectory + '/resources/js/vendor/masonry.min.js', function(){
                    am2.main.loadScript(am2.templateDirectory + '/resources/js/vendor/images-loaded.min.js', function(){
                        var $grid = $('.grid').masonry({
                            // options
                            itemSelector: '.grid-item',
                            columnWidth: '.grid-sizer',
                            percentPosition: true,
                            gutter: 25,
                            transitionDuration: '0.3s'
                        });
                        $grid.imagesLoaded().progress( function() {
                            $grid.masonry('layout');
                        });
                    });
                });
            }, 
            
            loadScript: function(url, callback) {
                // Adding the script tag to the head as suggested before
                var body = document.getElementsByTagName('body')[0];
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = url;

                // Then bind the event to the callback function.
                // There are several events for cross browser compatibility.
                script.onreadystatechange = callback;
                script.onload = callback;

                // Fire the loading
                body.appendChild(script);
            },
            
            googleMapV1: function(args) {

                var defaults = {}; 
                var options = $.extend( defaults, args );
                if(typeof (google) !== 'undefined' && typeof (google.maps) !== 'undefined') {
                    
                    var map = new google.maps.Map(document.getElementById('map__map'), {
                        zoom: 2,
                        maxZoom: 15,
                        scrollwheel: false,
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        closeBoxMargin: "10px 20px 2px 2px",
                        closeBoxURL: "http://www.google.com/intl/en_us/mapfiles/close.gif",
                        styles: options.mapStyle,
                       
                    });
                    
                    var infowindow = new google.maps.InfoWindow();
                    var iconBase = am2.template_directory+'/images/map/';
                   
                    infowindow.setOptions({
                        disableAutoPan: true,
                        maxWidth: 280,
                        closeBoxURL: iconBase + "infobox_close.png",
                    });
                    var marker, i;
                    var markerBounds = new google.maps.LatLngBounds();
                    var markers = new Array();

                    // Add a marker clusterer to manage the markers.
                    
                    for (i = 0; i < locations.length; i++) {
                        var Position = new google.maps.LatLng(locations[i][0], locations[i][1]);
                        
                        marker = new google.maps.Marker({
                            position: Position,
                            map: map,
                            icon: iconNormal,
                            //label: locations[i][0],
                            category: locations[i][2],
                            date: locations[i][4],
                            animation: google.maps.Animation.DROP
                          });
                      markers.push(marker);// slažemo array markera da ih možemo pozvati izvana
                      
                      markerBounds.extend(Position);

                      google.maps.event.addListener(marker, 'click', (function(marker, i) {
                        return function() {
                            for (var c=0; c<markers.length; c++) {
                                markers[c].setIcon(iconNormal);
                                markers[c].setZIndex(1);
                            }
                            var divHeightOfTheMap = document.getElementById('map__map').clientHeight;
                            var offSetFromBottom = 50;
                            map.setCenter(marker.getPosition());
                            map.panBy(0, 0);
                            var domain = document.location;
                            var html = '<svg id="infobox-close" class="svg-icon--close-dims"><use xlink:href="' + am2.child_template_directory + '/images/sprite.svg#icon--close"></use></svg>' + locations[i][5];
                            var infowindow = jQuery( '.map__info' );
                            infowindow.show();
                            infowindow.empty();
                            infowindow.append( html );
                            infowindow.addClass('active-info');

                            var infoclose = $('#infobox-close');
                            infoclose.click( function() {
                                infowindow.removeClass('active-info');
                                setTimeout(function () {
                                    infowindow.empty();
                                }, 300);

                            });
                            marker.setZIndex(2);
                        }
                      })(marker, i));
                    }
                    var markerCluster = new MarkerClusterer(map, markers,
                        {imagePath: am2.child_template_directory + '/images/m'});
                        // Then you call this method here.
                    map.fitBounds(markerBounds);
                }
                
            },

            initGoogleMaps: function(){
                function setMap(){
                    $('.js-init-map').each( function(i) {
                        var $el_id = $(this).attr('id');
                        var $lat = parseFloat( $(this).attr('data-lat') );
                        var $lng = parseFloat( $(this).attr('data-lng') );
                        var mapOptions = {
                            zoom: 7,
                            center: new google.maps.LatLng($lat, $lng)
                        };
                        var mapElement = document.getElementById($el_id);
                        var map = new google.maps.Map(mapElement, mapOptions);
                        var marker = new google.maps.Marker({
                            position: new google.maps.LatLng($lat, $lng),
                            map: map,
                            title: ''
                        });
                    });
                }
                //google.maps.event.addDomListener(window, 'load', setMap);
                setMap();
            },
        };

        am2.main.init = function () {
            
            var self = this;
            self.jsHeaderSearch();
            self.shareCount();
            //self.masonryGallery();
        }; 

        return am2.main.init();

    }($));
}